import { GetAllUsersByLocation } from 'domain/usecases/user/get-all-users';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetAllUsers extends BaseHttpService<GetAllUsersByLocation.Model> implements GetAllUsersByLocation {
  async getAllUsers(params: GetAllUsersByLocation.Params): Promise<GetAllUsersByLocation.Model> {
    return await this.request('get', {}, params);
  }
}
